import { render, staticRenderFns } from "./normalCmp.vue?vue&type=template&id=2bca7804&"
import script from "./normalCmp.vue?vue&type=script&lang=ts&"
export * from "./normalCmp.vue?vue&type=script&lang=ts&"
import style0 from "./normalCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports